'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /**
                                    * Created by lyj on 2016/4/24.
                                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _loginValidation = require('./loginValidation');

var _loginValidation2 = _interopRequireDefault(_loginValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reduxForm.reduxForm)({
  form: 'login',
  fields: ['name', 'password'],
  validate: _loginValidation2.default
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_Object$getPrototypeO = (0, _getPrototypeOf2.default)(Login)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.onHandleKeyDown = function (event) {
      var _this$props = _this.props;
      var _this$props$fields = _this$props.fields;
      var name = _this$props$fields.name;
      var password = _this$props$fields.password;
      var handleSubmit = _this$props.handleSubmit;
      // console.log(event);
      // console.log(event.keyCode);

      if (!!name && !!password && event.keyCode === 13) {
        handleSubmit();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onHandleKeyDown, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onHandleKeyDown, false);
    }
  }, {
    key: 'nameInit',
    value: function nameInit(value) {
      var name = this.props.fields.name;

      name.onChange(value);
    }
  }, {
    key: 'passwordInit',
    value: function passwordInit(value) {
      var password = this.props.fields.password;

      password.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Login.scss');
      var _props = this.props;
      var closeModalFunc = _props.closeModalFunc;
      var registerUrl = _props.registerUrl;
      var forgetPwdUrl = _props.forgetPwdUrl;
      var hideCloseModalBtn = _props.hideCloseModalBtn;
      var loginValid = _props.loginValid;
      var loginErrorMsg = _props.loginErrorMsg;
      var _props2 = this.props;
      var _props2$fields = _props2.fields;
      var name = _props2$fields.name;
      var password = _props2$fields.password;
      var handleSubmit = _props2.handleSubmit;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.loginPic },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/center-geren/denglu.jpg',
            alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.loginMes },
          _react2.default.createElement(
            'div',
            { className: styles.loginH1 },
            '登录'
          ),
          _react2.default.createElement(_GoeasyInputField2.default, { afterInit: this.nameInit.bind(this), label: '登录名：', inputType: 'text', formProps: name,
            inputPlaceholder: '请输入登录名/手机' }),
          _react2.default.createElement(_GoeasyInputField2.default, { afterInit: this.passwordInit.bind(this), label: '密码：', inputType: 'password',
            inputPlaceholder: '请输入密码'
            // keyDown={handleSubmit}
            , formProps: password }),
          loginValid === false ? _react2.default.createElement(
            'span',
            { className: styles.error },
            loginErrorMsg
          ) : '',
          _react2.default.createElement(
            'div',
            { className: styles.loginName },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.linkBtn, target: '_blank', to: forgetPwdUrl },
              '忘记密码？'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.linkBtn, target: '_blank', to: registerUrl },
              '新用户注册'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.loginName },
            _react2.default.createElement(
              'a',
              { className: styles.loginBtn, onClick: handleSubmit },
              '立即登录'
            ),
            hideCloseModalBtn ? '' : _react2.default.createElement(
              'a',
              { className: styles.loginBtn + ' ' + styles.loginCloseBtn,
                onClick: function onClick() {
                  return closeModalFunc ? closeModalFunc() : '';
                } },
              '关闭'
            )
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  loginValid: _react.PropTypes.bool,
  loginErrorMsg: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = Login;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Login/Login.js
 ** module id = 1368
 ** module chunks = 0
 **/